import tw, { styled } from 'twin.macro';

interface ArrowType {
  isOpen: boolean;
  isSmall?: boolean;
}

const Arrow = ({ isOpen, isSmall }: ArrowType) => {
  return (
    <StyledArrow isOpen={isOpen} isSmall={isSmall} viewBox="0 0 24 24">
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="m13.172 12-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" />
    </StyledArrow>
  );
};

const StyledArrow = styled.svg(({ isOpen, isSmall }: ArrowType) => [
  isSmall ? tw`w-5 h-5` : tw`w-7 h-7`,
  tw`rotate-90`,
  isOpen && tw`-rotate-90 fill-current`,
]);

export default Arrow;
